// automatically generated by the FlatBuffers compiler, do not modify

/* eslint-disable @typescript-eslint/no-unused-vars, @typescript-eslint/no-explicit-any, @typescript-eslint/no-non-null-assertion */

import * as flatbuffers from "flatbuffers";

import {
  GroupControlVariant,
  unionToGroupControlVariant,
  unionListToGroupControlVariant,
} from "./group-control-variant";
import {
  NormalGroupControl,
  NormalGroupControlT,
  verifyNormalGroupControl,
} from "./normal-group-control";
import {
  ValuedGroupControl,
  ValuedGroupControlT,
  verifyValuedGroupControl,
} from "./valued-group-control";

export class ElevatorGroupControlMessage implements flatbuffers.IUnpackableObject<ElevatorGroupControlMessageT> {
  bb: flatbuffers.ByteBuffer | null = null;
  bb_pos = 0;
  __init(i: number, bb: flatbuffers.ByteBuffer): ElevatorGroupControlMessage {
    this.bb_pos = i;
    this.bb = bb;
    return this;
  }

  static getRootAsElevatorGroupControlMessage(
    bb: flatbuffers.ByteBuffer,
    obj?: ElevatorGroupControlMessage,
  ): ElevatorGroupControlMessage {
    return (obj || new ElevatorGroupControlMessage()).__init(
      bb.readInt32(bb.position()) + bb.position(),
      bb,
    );
  }

  static getSizePrefixedRootAsElevatorGroupControlMessage(
    bb: flatbuffers.ByteBuffer,
    obj?: ElevatorGroupControlMessage,
  ): ElevatorGroupControlMessage {
    bb.setPosition(bb.position() + flatbuffers.SIZE_PREFIX_LENGTH);
    return (obj || new ElevatorGroupControlMessage()).__init(
      bb.readInt32(bb.position()) + bb.position(),
      bb,
    );
  }

  controlType(): GroupControlVariant {
    const offset = this.bb!.__offset(this.bb_pos, 4);
    return offset ? this.bb!.readUint8(this.bb_pos + offset) : GroupControlVariant.NONE;
  }

  control<T extends flatbuffers.Table>(obj: any): any | null {
    const offset = this.bb!.__offset(this.bb_pos, 6);
    return offset ? this.bb!.__union(obj, this.bb_pos + offset) : null;
  }

  static startElevatorGroupControlMessage(builder: flatbuffers.Builder) {
    builder.startObject(2);
  }

  static addControlType(builder: flatbuffers.Builder, controlType: GroupControlVariant) {
    builder.addFieldInt8(0, controlType, GroupControlVariant.NONE);
  }

  static addControl(builder: flatbuffers.Builder, controlOffset: flatbuffers.Offset) {
    builder.addFieldOffset(1, controlOffset, 0);
  }

  static endElevatorGroupControlMessage(builder: flatbuffers.Builder): flatbuffers.Offset {
    const offset = builder.endObject();
    builder.requiredField(offset, 6); // control
    return offset;
  }

  static createElevatorGroupControlMessage(
    builder: flatbuffers.Builder,
    controlType: GroupControlVariant,
    controlOffset: flatbuffers.Offset,
  ): flatbuffers.Offset {
    ElevatorGroupControlMessage.startElevatorGroupControlMessage(builder);
    ElevatorGroupControlMessage.addControlType(builder, controlType);
    ElevatorGroupControlMessage.addControl(builder, controlOffset);
    return ElevatorGroupControlMessage.endElevatorGroupControlMessage(builder);
  }

  unpack(): ElevatorGroupControlMessageT {
    return new ElevatorGroupControlMessageT(
      this.controlType(),
      (() => {
        const temp = unionToGroupControlVariant(this.controlType(), this.control.bind(this));
        if (temp === null) {
          return null;
        }
        return temp.unpack();
      })(),
    );
  }

  unpackTo(_o: ElevatorGroupControlMessageT): void {
    _o.controlType = this.controlType();
    _o.control = (() => {
      const temp = unionToGroupControlVariant(this.controlType(), this.control.bind(this));
      if (temp === null) {
        return null;
      }
      return temp.unpack();
    })();
  }

  unpackFields(...fields: string[]): ElevatorGroupControlMessageT {
    const t = new ElevatorGroupControlMessageT();
    const fieldSet = new Set(fields);
    if (fieldSet.has("control_type")) {
      t.controlType = this.controlType();
    }
    if (fieldSet.has("control")) {
      t.control = (() => {
        const temp = unionToGroupControlVariant(this.controlType(), this.control.bind(this));
        if (temp === null) {
          return null;
        }
        return temp.unpack();
      })();
    }
    return t;
  }
}

export class ElevatorGroupControlMessageT implements flatbuffers.IGeneratedObject {
  constructor(
    public controlType: GroupControlVariant = GroupControlVariant.NONE,
    public control: NormalGroupControlT | ValuedGroupControlT | null = null,
  ) {}

  pack(builder: flatbuffers.Builder): flatbuffers.Offset {
    if (this.control === null || this.control === undefined) {
      throw new Error('Required field "control" is not set');
    }
    const control = builder.createObjectOffset(this.control);

    return ElevatorGroupControlMessage.createElevatorGroupControlMessage(
      builder,
      this.controlType,
      control,
    );
  }

  clone(): ElevatorGroupControlMessageT {
    const obj = new ElevatorGroupControlMessageT();
    obj.controlType = this.controlType;
    obj.control =
      this.control !== null && typeof (this.control as any).clone === "function"
        ? (this.control as any).clone()
        : this.control;
    return obj;
  }

  equals(other: ElevatorGroupControlMessageT): boolean {
    if (this.controlType !== other.controlType) return false;
    if (this.control !== null && other.control !== null) {
      if (typeof (this.control as any).equals === "function") {
        if (!(this.control as any).equals(other.control)) return false;
      } else if (this.control !== other.control) return false;
    } else if (this.control !== other.control) return false;
    return true;
  }
}

export function verifyElevatorGroupControlMessage(
  verifier: flatbuffers.Verifier,
  tablePos: number,
): void {
  verifier.checkTable(tablePos);
  try {
    verifier.checkScalarField(tablePos, 4, 1);
    verifier.checkUnionConsistency(tablePos, 4, 6, "control");
    {
      const pos = verifier.checkOffsetField(tablePos, 6);
      if (pos !== 0) {
        const uType = verifier.readFieldUint8(tablePos, 4);
        switch (uType) {
          case 1: // NormalGroupControl
            {
              const o = verifier.readInt32(pos);
              verifyNormalGroupControl(verifier, pos + o);
            }
            break;
          case 2: // ValuedGroupControl
            {
              const o = verifier.readInt32(pos);
              verifyValuedGroupControl(verifier, pos + o);
            }
            break;
        }
      }
    }
    verifier.checkRequiredField(tablePos, 6, "control");
  } finally {
    verifier.popDepth();
  }
}
